module.exports = __webpack_public_path__ + "img/Show you can.8ff9d5ed.svg";